import { useForm } from "react-hook-form";
import { FormContainer, TextInput } from "../../shared";
import useGlobalMutation from "../../../hooks/useGlobalMutation";
import { UPDATE_SITE_ADMIN_USER } from "./query";
import { RegexPattern } from "../../../utils";

const UpdateAdminUser = ({ data }) => {
    const { id, firstName, lastName, email, phone } = data;

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        mode: "onChange",
        defaultValues: {
            firstName,
            lastName,
            email,
            phone,
        },
    });

    const { submitMutation, loading } = useGlobalMutation(UPDATE_SITE_ADMIN_USER);

    const submitAction = handleSubmit(async (data) => {
        const { firstName, lastName, email, phone } = data;

        const variables = {
            id,
            userPatch: {
                firstName,
                lastName,
                email,
                phone,
            },
        };

        const dataPath = "updateUserById.user";
        const successMessage = "Admin Update Successfully";

        await submitMutation(variables, dataPath, successMessage);
    });
    return (
        <FormContainer
            submitAction={submitAction}
            loading={loading}
            submitButtonText="Update"
            submitBtnSm
        >
            <h5 className="mb-4">Update Admin</h5>

            <div className="row">
                <div className="col-md-6">
                    <TextInput
                        id="firstName"
                        labelText="First Name"
                        {...register("firstName", {
                            required: true,
                            pattern: RegexPattern.name,
                        })}
                        isInvalid={!!errors.firstName}
                        required
                    />
                </div>

                <div className="col-md-6">
                    <TextInput
                        id="lastName"
                        labelText="Last Name"
                        {...register("lastName", {
                            required: true,
                            pattern: RegexPattern.name,
                        })}
                        isInvalid={!!errors.lastName}
                        required
                    />
                </div>

                <div className="col-md-6">
                    <TextInput
                        id="email"
                        type="email"
                        labelText="Email"
                        {...register("email", {
                            required: true,
                            pattern: RegexPattern.email,
                        })}
                        isInvalid={!!errors.email}
                        required
                    />
                </div>

                <div className="col-md-6">
                    <TextInput
                        id="phone"
                        type="number"
                        labelText="Phone"
                        {...register("phone", {
                            pattern: RegexPattern.number,
                        })}
                        isInvalid={!!errors.phone}
                    />
                </div>
            </div>
        </FormContainer>
    );
};

export default UpdateAdminUser;
